import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getPlanEntryGridState } from '../../../redux/selectors/planEntries'
import {
  loadPlanEntries,
  addFilter,
  removeFilter,
  changeOrder,
  setInitialFilters,
  clearFilter,
  changeLayout,
  clearPlanEntries,
  clearAllFilters
} from '../../../redux/actions/planEntries'

import { getCategoryRelationships } from '../../../redux/selectors/planCategoryPlanSubcategories'
import SelectedFiltersDisplay from '../../filtersRow/SelectedFiltersDisplay'
import ClassFinderNewSortAndClear from './ClassFinderNewSortAndClear'

import {
  getFilteredItemLabels,
  isCategoryAlreadyFiltered
} from './classFinderHelperMethods'
import ClassFinderMobileFilter from './ClassFinderMobileFilter'

const FILTER_BY_FIELDS = {
  instructors: 'slug',
  styles: 'slug',
  intensities: 'level'
}

class ClassFinderNewFilteredList extends React.Component {
  constructor(props) {
    super(props)

    this.initialDuration = {
      min:
        this.props.preloadedFilters.min ||
        this.props.dropdownOptions.duration.min,
      max: this.props.preloadedFilters.max
    }

    this.state = {
      activeDropdown: '',
      displayedDurationMinMax: this.initialDuration
    }
    this.reorderEntries = this.reorderEntries.bind(this)
    this.instructorFilterExcluded = this.instructorFilterExcluded.bind(this)
    this.pushWindowState = this.pushWindowState.bind(this)
    this.removeFilter = this.removeFilter.bind(this)
    this.clearAllFilters = this.clearAllFilters.bind(this)

    this.productTop = React.createRef()

    this.excludedFilters = this.instructorFilterExcluded()
      ? ['instructors']
      : []
  }

  componentDidMount() {
    window.onpopstate = (event) => {
      if (event.state) {
        const previousFilteredState = event.state
        this.props.setInitialFilters(previousFilteredState)
        this.props.loadPlanEntries()
      }
    }
  }

  pushWindowState() {
    window.history.pushState(
      this.props.filteredAttributes,
      null,
      `${this.props.baseUrl}?${this.props.filterUrl}`
    )
  }

  removeFilter(filterSection, filter, options) {
    const filterOptions = {
      yoga: { filterByField: 'slug' },
      fitness: { filterByField: 'slug' },
      mindfulness: { filterByField: 'slug' },
      wellness: { filterByField: 'slug' },
      skills: { filterByField: 'slug' },
      duration: { filterByField: null },
      difficulties: { filterByField: null },
      focus_area: { filterByField: null },
      equipment: { filterByField: null },
      intensities: { filterByField: 'level' },
      instructors: { filterByField: 'slug' }
    }
    if (filterSection === 'duration') {
      this.setState({
        displayedDurationMinMax: {
          min: this.props.dropdownOptions.duration.min
        }
      })
    }
    const filterByField = filterOptions[filterSection].filterByField
    this.props.removeFilter(filterSection, filter, filterByField, options)
    this.props.loadPlanEntries(this.pushWindowState)
  }

  clearAllFilters() {
    this.props.clearAllFilters()
    this.props.loadPlanEntries(this.pushWindowState)
  }

  reorderEntries(order) {
    this.props.changeOrder(order)
    this.props.loadPlanEntries(this.pushWindowState)
  }

  instructorFilterExcluded() {
    return this.props.dropdownOptions.instructors?.length < 2
  }

  render() {
    const filteredLabels = getFilteredItemLabels({
      filteredAttributes: this.props.filteredAttributes,
      excludedFilters: this.excludedFilters || [],
      categoryRelationships: this.props.categoryRelationships
    })
    return (
      <>
        <SelectedFiltersDisplay
          filteredItemLabels={filteredLabels}
          onLabelClick={this.removeFilter}
        />
        <ClassFinderNewSortAndClear
          filteredItemLabels={filteredLabels}
          onClearAll={this.clearAllFilters}
          totalProducts={this.props.total}
          order={this.props.order}
          onSort={this.reorderEntries}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  const planEntryGridState = getPlanEntryGridState(state)
  return {
    filteredAttributes: state.ui.planEntries.filtered,
    filterUrl: state.ui.planEntries.filterUrl,
    total: parseInt(planEntryGridState.total),
    order: state.ui.planEntries.order,
    categoryRelationships: getCategoryRelationships(state),
    layout: planEntryGridState.layout
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlanEntries: (callback) => {
      dispatch(clearPlanEntries())
      dispatch(loadPlanEntries(callback))
    },
    removeFilter: (filterSection, filterField, filterByField, options) => {
      dispatch(removeFilter(filterSection, filterField, filterByField, options))
    },
    changeOrder: (order) => {
      dispatch(changeOrder(order))
    },
    setInitialFilters: (filters) => {
      dispatch(setInitialFilters(filters))
    },
    clearFilter: (label) => {
      dispatch(clearFilter(label))
    },
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    }
  }
}

ClassFinderNewFilteredList.propTypes = {
  baseUrl: PropTypes.string,
  clearInstructorFilter: PropTypes.func,
  changeOrder: PropTypes.func,
  addFilter: PropTypes.func,
  filterUrl: PropTypes.string,
  removeFilter: PropTypes.func,
  loadPlanEntries: PropTypes.func,
  order: PropTypes.string,
  filteredAttributes: PropTypes.object,
  preloadedFilters: PropTypes.object,
  includeFilters: PropTypes.bool,
  setInitialFilters: PropTypes.func,
  total: PropTypes.number,
  clearFilter: PropTypes.func,
  selectLayout: PropTypes.func,
  withSubcategories: PropTypes.bool,
  dropdownOptions: PropTypes.object,
  layout: PropTypes.string
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassFinderNewFilteredList)
